import React, { useEffect } from 'react'
import styles from '../../../styles/HomeLanding/IndiaLandingPage.module.css'
import Image from 'next/image'
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';

const WhyQueueBuster = () => {
    const router = useRouter();
    const isLandingPage = router?.asPath === '/landing-page';



    useEffect(() => {
        let pin1, pin2, pin3;

        const initializeGSAP = async () => {
            if (typeof window !== 'undefined') {
                const gsapModuleLoaded = await import('gsap');
                const ScrollTriggerModuleLoaded = await import('gsap/dist/ScrollTrigger');

                const gsapInstance = gsapModuleLoaded.default;
                const ScrollTriggerInstance = ScrollTriggerModuleLoaded.ScrollTrigger ?? ScrollTriggerModuleLoaded.default?.ScrollTrigger ?? ScrollTriggerModuleLoaded.default;

                gsapInstance.registerPlugin(ScrollTriggerInstance);

                pin1 = ScrollTriggerInstance.create({
                    trigger: `.${styles.pie_chart}`,
                    start: "50% bottom",
                    onEnter: () => gsapInstance.to(`.${styles.pie_chart}`, { width: "12rem", height: "5.5rem", duration: 0.5 }),
                    onLeave: () => gsapInstance.to(`.${styles.pie_chart}`, { height: 0, width: 0, duration: 0.5 }),
                    onEnterBack: () => gsapInstance.to(`.${styles.pie_chart}`, { width: "12rem", height: "5.5rem", duration: 0.5 }),
                    onLeaveBack: () => gsapInstance.to(`.${styles.pie_chart}`, { height: 0, width: 0, duration: 0.5 }),
                });

                pin2 = ScrollTriggerInstance.create({
                    trigger: `.${styles.pie_chart2}`,
                    start: "50% bottom",
                    onEnter: () => gsapInstance.to(`.${styles.pie_chart2}`, { width: "4.5rem", height: "4.5rem", duration: 0.5 }),
                    onLeave: () => gsapInstance.to(`.${styles.pie_chart2}`, { height: 0, width: 0, duration: 0.5 }),
                    onEnterBack: () => gsapInstance.to(`.${styles.pie_chart2}`, { width: "4.5rem", height: "4.5rem", duration: 0.5 }),
                    onLeaveBack: () => gsapInstance.to(`.${styles.pie_chart2}`, { height: 0, width: 0, duration: 0.5 }),
                });

                pin3 = ScrollTriggerInstance.create({
                    trigger: `.${styles.star_WQB}`,
                    start: "50% bottom",
                    onEnter: () => gsapInstance.to(`.${styles.star_WQB}`, { rotation: 0, duration: 0.6, ease: "power2.out" }),
                    onLeave: () => gsapInstance.to(`.${styles.star_WQB}`, { rotation: 40, duration: 0.6, ease: "power2.out" }),
                    onEnterBack: () => gsapInstance.to(`.${styles.star_WQB}`, { rotation: 0, duration: 0.6, ease: "power2.out" }),
                    onLeaveBack: () => gsapInstance.to(`.${styles.star_WQB}`, { rotation: 40, duration: 0.6, ease: "power2.out" }),
                });
            }
        };

        initializeGSAP();

        return () => {
            if (pin1) pin1.kill();
            if (pin2) pin2.kill();
            if (pin3) pin3.kill();
        };
    }, []);
    return (
        <div className={styles.whyQueueBusterContainer}>

            <div className={styles.quickword_title}>
                <div className={styles.header}>Features</div>
                <h4 style={{ fontSize: "2.8rem", fontFamily: "GilroyBold", lineHeight:"4rem" }}>What Makes <span style={{ color: "#1264A3" }}> QueueBuster </span>The Right Choice?</h4>
            </div>
            <div className={styles.gridContainer}>
                <div className={`${styles.gridBox} ${styles.box1}`}>
                    <div style={{ position: "relative", height: "5rem", width: '5rem',flexShrink:0 }}><Image src="/assets/HomeLanding/save-money.svg" fill alt='Cost Effective' /></div>
                    <h3 style={{fontSize:"2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", margin:"0.8rem 0 1rem 0"}}>Cost Effective & Affordable</h3>
                    <p  className={styles.gridContainer_text}>The next-gen POS billing software which is economical and budget friendly. We’ve got it all so that your business has it all.</p>
                    <div className={styles.roundCircle3}></div>
                <div className={styles.roundCircle4}></div>
                </div>
                <div className={`${styles.gridBox} ${styles.box2}`}>
                    <div style={{ position: 'absolute', width: "100%", height: '39rem', zIndex: 1, bottom: 0 }}><Image src="/assets/HomeLanding/Gradient-bg.svg" fill alt="Gradient" /></div>
                    <div style={{ position: "relative", width: "100%",bottom:"-8rem" }}>
                        <div className={styles.feature_img}>
                            <Image
                                src="/assets/HomeLanding/new_feature_img.webp"
                                fill
                                alt="Smart POS solution India"
                                sizes="(max-width: 768px) 60vw, 220px"
                                quality={75}
                            />
                        </div>
                        <div className={styles.pie_chart}>
                            <Image
                                src="/assets/HomeLanding/Card_Statistic.webp"
                                fill
                                alt="Offline POS software for India stores"
                                sizes="120px"
                                quality={75}
                            />
                        </div>
                        <div className={styles.pie_chart2}>
                            <Image
                                src="/assets/HomeLanding/new_icon.webp"
                                fill
                                alt="Retail POS billing India"
                                sizes="80px"
                                quality={75}
                            />
                        </div>
                    </div>
                    <div  className={styles.star_WQB}><Image src="/assets/HomeLanding/star_WQB.svg" fill alt='Retail POS billing UAE' /></div>

                    <h3 style={{ position: "relative",fontSize:"2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", margin:"1rem 0", zIndex: 1 ,}}>One POS Solution, Endless Possibilities.</h3>
                    <p  className={styles.gridContainer_text}  style={{position:"relative",zIndex:1}}>QueueBuster offers more than just point of sale, it also streamlines warehouse management, multi-store operations, and vendor management.</p>
                </div>
                <div className={`${styles.gridBox} ${styles.box3}`}>
                    <div style={{ position: "relative", height: "10rem", width: '10rem' }}><Image src="/assets/HomeLanding/clouds.svg" fill alt='Cost Effective' /></div>
                    <h3 style={{fontSize:"2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", margin:"1rem 0",}}>Cloud-based Solution</h3>
                    <p className={styles.gridContainer_text} >Ensures greater reliability and security due to cloud-based protection. Safeguards your data while maintaining seamless performance.</p>
                     <div className={styles.roundCircle5}></div>
                    <div className={styles.roundCircle6}></div>
                </div>
                <div className={`${styles.gridBox} ${styles.box4}`}>
                    <div style={{ position: "relative", height: "5rem", width: '5rem' }}><Image src="/assets/HomeLanding/Real-timeReporting.svg" fill alt='Cost Effective' /></div>
                    <h3 style={{fontSize:"2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", margin:"1rem 0",}}>Real-time Reporting</h3>
                    <p className={styles.gridContainer_text}>With QueueBuster’s reporting and analytics feature, you can track your customer data, manage multiple outlets and can thus make better decisions allowing your business to grow.</p>
                    
                </div>

            </div>
        </div>
    )
}

export default WhyQueueBuster
